import React from 'react';
import { Box } from 'reflexbox';
import { FormLabel, PrivateIcon, PublicIcon, SwitchButton } from 'boss-ui';
import { TEAM_FIELD_VISIBILITY } from 'boss-ui/src/constants';
import SwitchHelpTooltip from './SwitchHelpTooltip';
import SwitchAndTooltipContainer from './SwitchAndTooltipContainer';

export default function VisibilityToggle(props) {
  const { fieldValue, handleFieldChange } = props;
  return (
    <Box style={{ position: 'relative' }}>
      <FormLabel>Team Visibility</FormLabel>
      <SwitchAndTooltipContainer>
        <SwitchButton
          checked={fieldValue}
          handleToggle={handleFieldChange}
          id={TEAM_FIELD_VISIBILITY}
          onIcon={<PublicIcon />}
          offIcon={<PrivateIcon />}
          onText="Public"
          offText="Private"
        />
        <SwitchHelpTooltip tooltip_id="visibility_question"
                           text={`Public: the team members' names appear to others during the team formation process.`} />
      </SwitchAndTooltipContainer>
    </Box>
  );
}
